const DEFAULT_ARTIST = 'Zachary Gray';

function isVariousArtists(name: string): boolean {
  return /^various artists$/i.test(name.trim());
}

/**
 * Track artist → release artist → Zachary Gray.
 * Album-level "Various Artists" is never shown as the performing artist.
 */
export function resolveTrackArtist(
  trackArtist?: string | null,
  releaseArtist?: string | null,
  fallback = DEFAULT_ARTIST,
): string {
  const track = trackArtist?.trim();
  if (track) return track;
  const release = releaseArtist?.trim();
  if (release && !isVariousArtists(release)) return release;
  return fallback;
}
